import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { createVotingApi, getStarsApi, updateStarsApi, getAllUsersVotedApi, getAverageStarsApi } from '../../api/voting.api';
import { showSignInPopup } from '../../redux/auth.slice';
import { updateTime } from '../../redux/realtime.slice';
import Voting from '../../components/RecipeDetailComponent/Voting';

const VotingContainer = ({ recipe, toast }) => {
    const [currentValue, setCurrentValue] = useState(0);
    const [hoverValue, setHoverValue] = useState(undefined);
    const [isShowModal, setShowModal] = useState(false);
    const [starsAvg, setStarsAvg] = useState(0);
    const [allUsers, setAllUsers] = useState(0);

    const currentUser = useSelector(state => state.auth.signIn.currentUser);
    const time = useSelector(state => state.time.value);
    const dispatch = useDispatch();
    const stars = Array(5).fill(0);
    const token = currentUser?.token;

    const handleClick = value => {
        setCurrentValue(value)
    }

    const handleMouseOver = newHoverValue => {
        setHoverValue(newHoverValue)
    };

    const handleMouseLeave = () => {
        setHoverValue(undefined)
    }

    function getAverageStars(recipe) {
        getAverageStarsApi(recipe.id)
            .then(res => {
                setStarsAvg(Number(res.data).toFixed(2))
            })
            .catch(err => {
                console.log(err)
            })
    }

    function getAllUsers(recipe) {
        getAllUsersVotedApi(recipe.id)
            .then(res => {
                setAllUsers(Number(res.data))
            })
            .catch(err => {
                console.log(err)
            })
    }

    function handleClickVoting() {
        if (currentUser) {
            const data = {
                userId: currentUser.id,
                recipeId: recipe.id,
                stars: currentValue
            };
            if (currentUser) {
                createVotingApi(data, token)
                    .then(res => {
                        if (res.data === "Failed") {
                            // toast.error('You have rated!');
                            handleUpdateStars(data, token)
                        } else {
                            toast.success('Rating success!');
                        }
                    })
                    .then(() => {
                        dispatch(updateTime());
                    })
                    .catch((err) => {
                        toast.error('Rating error!');
                    })
            } else {
                setShowModal(true);
            }
        } else {
            dispatch(showSignInPopup());
        }
    }

    function handleUpdateStars(data, token) {
        updateStarsApi(data, token)
            .then(res => {
                toast.success('Update stars success!');
            })
            .then(() => {
                setTimeout(() => getAverageStars(recipe), 400)
            })
            .catch(err => {
                toast.error('Rating again failed!');
            })
    }

    useEffect(() => {
        currentUser && getStarsApi({
            userId: currentUser.id,
            recipeId: recipe?.id,
        }, token)
            .then(res => {
                setCurrentValue(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [currentUser, recipe, token])

    useEffect(() => {
        recipe && getAverageStars(recipe);
    }, [recipe, time])

    useEffect(() => {
        recipe && getAllUsers(recipe);
    }, [recipe, time])

    return (
        <Voting
            allUsers={allUsers}
            currentValue={currentValue}
            handleClick={handleClick}
            handleClickVoting={handleClickVoting}
            handleMouseLeave={handleMouseLeave}
            handleMouseOver={handleMouseOver}
            hoverValue={hoverValue}
            isShowModal={isShowModal}
            setShowModal={setShowModal}
            stars={stars}
            starsAvg={starsAvg}
        />
    )
}

export default VotingContainer